module.exports = __webpack_public_path__ + "img/speaker-s1.fd2c8585.jpg";